import React from 'react';
import PropTypes from 'prop-types';

import { useTableContext } from '../TableContext';
import Actions from '../Actions';
import BaseSelect from '../../Select';

export default function SelectFilter({ name, isMulti, options }) {
  const { state, dispatch } = useTableContext();

  let parsedOptions = [];

  if (options && (typeof options[0] === 'object')) {
    parsedOptions = options;
  } else {
    const uniqueOptions = [...new Set(options)];
    parsedOptions = uniqueOptions.map((option) => ({ label: option, value: option.toString().toLowerCase() }));
  }

  const filters = state.selectedFilters[name] || [];
  const filterValues = parsedOptions.filter((option) => filters.includes(option.value));

  return (
    <BaseSelect
      id="select-table-filter"
      placeholder={`Select ${name}`}
      isMulti={isMulti}
      value={filterValues.length ? filterValues : null}
      options={parsedOptions}
      onChange={(selectedOptions) => Actions.searchBySelect(dispatch, name, selectedOptions)}
    />
  );
}

SelectFilter.propTypes = {
  name: PropTypes.string.isRequired,
  isMulti: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ).isRequired,
};
